<template>
	<div class="m-l-50 m-t-0 w-1200">
		<el-form ref="form" :model="form" :rules="rules" label-width="130px">
      <el-tabs v-model="activeName">
      <el-tab-pane label="票据类型" name="first" class="form-pane">
  			<el-form-item label="类型名称" prop="cost_name">
  				<el-input v-model.trim="form.cost_name" class="h-40 w-400"></el-input>
        </el-form-item>
      </el-tab-pane>
       <el-tab-pane label="票据类型相关" name="second" class="form-pane">
        <el-form-item label="" prop="config_list">
            <el-row v-for="(item,index) in form.config_list">
                <el-col :span="24" :key="index" style="margin-top:15px;margin-bottom:15px;">
                  {{index+1}}、配置名称：<el-input v-model="item.name" class="h-40 w-200 m-r-30"></el-input>
                  配置类型：<el-select v-model="item.type" class="h-40 w-200 m-r-30" placeholder="请选择">
                    <el-option key="1" label="输入框" :value="1"></el-option>
                    <el-option key="2" label="选择框" :value="2"></el-option>
                    <el-option key="3" label="城市" :value="3"></el-option>
                    <el-option key="4" label="日期" :value="4"></el-option>
                  </el-select>
                  必填：<el-checkbox v-model="item.is_must"></el-checkbox>
                  <el-button size="small" type="danger" class="m-l-30" @click="configDel(index,form.config_list)" plain>删除配置</el-button>
                </el-col>
                <el-col v-if="item.type==2 && item.value_list.length>0" :span="24" v-for="(item1,index1) in item.value_list" :key="index1" style="margin-bottom:15px;margin-left:42px;">
                    选项{{index1+1}}：<el-input v-model="item1.value" class="h-40 w-200"></el-input>
                    <el-button size="small" type="danger" class="m-l-30" @click="valueDel(index1,item.value_list)" plain>删除选项</el-button>
                </el-col>
                <el-col :span="24" style="margin-bottom:15px">
                  <el-button v-if="item.type==2" size="small" type="primary" class="m-l-50 m-t-50" @click="valueAdd(item.value_list)" plain>增加选项</el-button>
                </el-col>
            </el-row>
            <el-row style="margin-top:15px">
              <el-col :span="24" style="margin-top:15px">
                <el-button size="small" type="primary" class="m-l-50" @click="configAdd(form.config_list)">增加配置</el-button>
              </el-col>
              <p><span v-if="form.config_list.length>0" style="color:#f00">备注：修改完成后请点击下方的保存，否则修改无效（删除配置及内容除外）</span></p>
            </el-row>
        </el-form-item>
       </el-tab-pane>
      </el-tabs>
        <el-form-item>
          <el-button type="primary" @click="add()" size="small" :loading="isLoading">保 存</el-button>
          <el-button @click="goback()" size="small">返 回</el-button>
        </el-form-item>
		</el-form>
    <preview ref="preview" :url="propsImg"></preview>
	</div>
</template>
<style scoped>
.form-pane{
  color:#333;
}
</style>
<script>
  import http from '../../../../assets/js/http'
  import fomrMixin from '../../../../assets/js/form_com'
  import preview from '../../../Common/preview.vue'
  export default {
    data() {
      return {
        isLoading: false,
        activeName: 'first',
        id: '',
        form: {
          cost_name: '',
          config_list: {
            value_list:[]
          }
        },
        rules: {
          cost_name: [
            { required: true, message: '请输入类型名' }
          ]
        }
      }
    },
    methods: {
      valueAdd(el){
          el.push({value:''})
      },
      valueDel(i, el){
          this.$confirm('确认删除选项' + (i + 1) + '?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if (el[i].id) {
              this.apiGet('admin/cost/del_config_value/id/' + el[i].id).then((res) => {
                this.handelResponse(res, (data) => {
                  _g.toastMsg('success', data)
                  setTimeout(() => {
                    el.splice(i, 1)
                  }, 0)
                }, () => {
                })
              })
            } else {
              el.splice(i, 1);
            }
          }).catch((error) => {
            console.log(error)
          })
      },
      configAdd(el){
          el.push({ value_list: [], name: '', type: 1, is_must: 0, pid: this.id })
      },
      configDel(i,el){
          this.$confirm('确认删除配置' + (i + 1) + '?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if(el[i].id){
              this.apiGet('admin/cost/del_config/id/' + el[i].id).then((res) => {
                this.handelResponse(res, (data) => {
                  _g.toastMsg('success', data)
                  setTimeout(() => {
                    el.splice(i, 1)
                  }, 0)
                }, () => {
                })
              })
            }else{
              el.splice(i,1);
            }
          }).catch(() => {
          })
      },
      add() {
        this.$refs.form.validate((pass) => {
          if (pass) {
            // alert(JSON.stringify(this.form))
            this.isLoading = !this.isLoading
            this.apiPut('admin/cost/', this.id, this.form).then((res) => {
              this.handelResponse(res, (data) => {
                _g.toastMsg('success', '保存成功')
                setTimeout(() => {
                  this.goback()
                }, 1500)
                // setTimeout(() => {
                //   router.push({ name: 'costEdit', params: { id: this.id }})
                // }, 1500)
                // this.getCompleteData()
                this.isLoading = !this.isLoading
              }, () => {
                this.isLoading = !this.isLoading
              })
            })
          }
        })
      },
      async getCompleteData() {
        this.apiGet('admin/cost/' + this.id).then((res) => {
          this.handelResponse(res, (data) => {
            this.form.cost_name = data.cost_name
            this.form.config_list = data.config_list
          })
        })
      }
    },
    created() {
      this.id = this.$route.params.id
      this.getCompleteData()
      _g.closeGlobalLoading()
    },
    components: {
      preview
    },
    mixins: [http, fomrMixin]
  }
</script>


// WEBPACK FOOTER //
// edit.vue?27d4e23e